import { useMutation } from '@tanstack/react-query';
import { projectService, CreateProjectPayload } from '@services/project';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { PROJECTS_BY_STATE_QUERY_KEY } from './useProjectsByState';
import { PROJECTS_QUERY_KEY } from './useProjects';
import { PROJECT_QUERY_KEY } from './useProject';
import { Project } from '@models/project.model';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateProject = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['projects'],
    mutationFn: async (payload: CreateProjectPayload) => {
      return await projectService.createProject(payload);
    },
    onSuccess: async (data: Project) => {
      toast.success(tActionMessages.projectCreatedSuccessfully);

      // Invalidate all project-related queries to trigger refetch
      await queryClient.invalidateQueries({ queryKey: [PROJECTS_QUERY_KEY] });
      await queryClient.invalidateQueries({
        queryKey: [PROJECTS_BY_STATE_QUERY_KEY],
      });
      await queryClient.invalidateQueries({ queryKey: [PROJECT_QUERY_KEY] });

      // Wait a bit for queries to refetch
      await queryClient.refetchQueries({
        queryKey: [PROJECTS_BY_STATE_QUERY_KEY],
      });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useCreateProject;
